import { useState } from 'react';
import './AddUserWMSLayer.css';

interface AddUserWMSLayerProps {
  onAdd: (layer: { name: string; url: string; layers: string; transparent: boolean }) => void;
}

const AddUserWMSLayer = ({ onAdd }: AddUserWMSLayerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [layers, setLayers] = useState('');
  const [transparent, setTransparent] = useState(true);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!name.trim() || !url.trim() || !layers.trim()) {
      alert('Please fill in all required fields');
      return;
    }

    onAdd({
      name: name.trim(),
      url: url.trim(),
      layers: layers.trim(),
      transparent
    });

    // Reset form
    setName('');
    setUrl('');
    setLayers('');
    setTransparent(true);
    setIsOpen(false);
  };

  return (
    <div className="add-user-wms-layer">
      <button
        className="add-wms-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? '− Cancel' : '+ Add Personal WMS Layer'}
      </button>

      {isOpen && (
        <form className="wms-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="layer-name">Layer Name *</label>
            <input
              id="layer-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="My Custom Layer"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="wms-url">WMS URL *</label>
            <input
              id="wms-url"
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://example.com/wms"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="wms-layers">Layer(s) *</label>
            <input
              id="wms-layers"
              type="text"
              value={layers}
              onChange={(e) => setLayers(e.target.value)}
              placeholder="layer_name"
              required
            />
            <small>Comma-separated if multiple</small>
          </div>

          <div className="form-group checkbox-group">
            <input
              id="transparent"
              type="checkbox"
              checked={transparent}
              onChange={(e) => setTransparent(e.target.checked)}
            />
            <label htmlFor="transparent">Transparent background</label>
          </div>

          <button type="submit" className="submit-button">
            Add Layer
          </button>
        </form>
      )}
    </div>
  );
};

export default AddUserWMSLayer;
